<div class="row">
  @for (filter of filters; track filter) {
    <div class="col-12 col-lg-6 col-xl-4">
      <input type="checkbox" [id]="filter" [checked]="vehicleMaintenanceSearchState.selectedFilters?.includes(filter)"
             (click)="toggleSelectedFilters(filter)">
      <label class="mb-2" [for]="filter"
             [attr.data-cy]="'vehicle-maintenance.filter.' + filter">{{ 'vehicle-maintenance.list.search-filter.' + filter | translate }}</label>
    </div>
  }
</div>
